<template>
  <div class="list-table">
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                clearable
                flat
                hide-details
                placeholder="Busqueda..."
                solo
                v-model="search"
              ></v-text-field>
              <v-btn icon>
                <v-icon @click="onSearch">search</v-icon>
              </v-btn>
              <v-btn @click="onDownload" icon color="success">
                <v-icon>cloud_download</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="labs"
                :loading="pagination.loading"
                :total-items="pagination.totalItems"
                hide-actions
                no-data-text="Datos no disponibles"
                no-results-text="No se encontraron registros coincidentes"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-left">{{ props.item.name }}</td>
                  <td class="text-sm-left">{{ props.item.phone }}</td>
                  <td v-if="props.item.contact !== null">
                    {{ props.item.contact.firstName }}
                    {{ props.item.contact.lastName }}
                  </td>
                  <td v-else></td>
                  <td v-if="props.item.accounting !== null">
                    {{ props.item.accounting.firstName }}
                    {{ props.item.accounting.lastName }}
                  </td>
                  <td v-else></td>
                  <td class="text-sm-left">
                    <v-btn
                      :to="`/laboratorios/editar/${props.item.id}`"
                      color="info"
                      flat
                      icon
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div class="text-xs-center pt-2" v-if="pagination.pages">
            <v-pagination
              :length="pagination.pages"
              :total-visible="7"
              @input="asyncPagination"
              v-model="pagination.page"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog max-width="350" persistent v-model="loading">
      <loading></loading>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import loading from './../dialog/DialogLoading'

export default {
  components: {
    loading,
  },
  data() {
    return {
      search: '',
      loading: true,
      pagination: {
        page: 1,
        rpp: this.$config.resultsPerPage,
        totalItems: 0,
        loading: true,
        pages: 0,
        search: {},
      },
      complex: {
        headers: [
          {
            text: 'Nombre',
            value: 'name',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Telefono',
            value: 'phone',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Contacto',
            value: 'contact.firstName',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Contable',
            value: 'accounting.firstName',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Acciones',
            align: 'left',
            sortable: false,
          },
        ],
      },
    }
  },
  created() {
    this.asyncPagination()
  },
  methods: {
    helperPaginate(response) {
      this.pagination.totalItems = response.total
      this.pagination.pages =
        Math.ceil(this.pagination.totalItems / this.pagination.rpp) || 0
      this.loading = false
      this.pagination.loading = false
    },
    asyncPagination() {
      this.pagination.loading = true

      let filter = {
        rpp: this.pagination.rpp,
        page: this.pagination.page,
        ...this.pagination.search,
      }

      return new Promise(resolve => {
        this.$store.dispatch('laboratories/getAll', filter).then(response => {
          this.helperPaginate(response)
          return resolve()
        })
      })
    },
    onSearch() {
      const params = { term: this.search }

      Object.keys(params).forEach(function(key) {
        if (params[key] == null || params[key] == '') delete params[key]
      })

      this.pagination.search = params
      this.pagination.page = 1
      this.asyncPagination()
    },
    onDownload() {
      const filter = {
        ...this.pagination.search,
      }
      this.$socket.emit('exportLabs', filter)
    },
  },
  computed: {
    ...mapState({
      labs: state => state.laboratories.all,
    }),
  },
}
</script>
